import { Splide } from '@splidejs/splide';

/**
 * SlideBanner
 * 中央寄せ・ループの画像バナースライダー（事例の実績バナー等）。両隣がちら見し、左右アローと下のバーで操作。
 * スライドは画像のみ（リンクなし）。スライド幅はCSS（.splide__slide）側で指定し perPage:'auto' で参照する。
 * 複数インスタンス対応。
 *
 * @example
 * <div class="splide js-slide-banner">
 *   <div class="splide__track"><ul class="splide__list">
 *     <li class="splide__slide"><figure><img …></figure></li> …
 *   </ul></div>
 * </div>
 */
export default class SlideBanner {
  constructor(options = {}) {
    this.selector = options.selector || '.js-slide-banner';
    document.querySelectorAll(this.selector).forEach((el) => this.setup(el));
  }

  /**
   * @param {HTMLElement} el
   */
  setup(el) {
    try {
      const slideCount = el.querySelectorAll('.splide__slide').length;
      const splide = new Splide(el, {
        type: 'loop',
        focus: 'center',
        perPage: 1,
        fixedWidth: '60rem',
        perMove: 1,
        gap: '4rem',
        arrows: true,
        pagination: slideCount > 1, // 1枚のときはインジケータ非表示
        drag: true,
        breakpoints: {
          768: { fixedWidth: '29.5rem', gap: '2.4rem' },
        },
      });
      splide.mount();
    } catch (error) {
      console.error('SlideBanner: Failed to initialize Splide', error);
    }
  }
}
